import PageLabelBar from "../../components/common/PageLabelBar/PageLabelBar";

export default function Skills() {
    return (
        <div className="content">
            <PageLabelBar title="Le tue Skills" />
        </div>
    );
}